import { createRouter, createWebHistory } from 'vue-router'
import Index from "@/view/Index.vue";
import AboutUs from "@/view/AboutUs.vue";
import Business from "@/view/Business.vue";
import Project from "@/view/Project.vue";
import Create from "@/view/Create.vue";
import Cooperate from "@/view/Cooperate.vue";
import JustCreate from "@/view/JustCreate.vue";
import Service from "@/view/Service.vue";
import Company from "@/view/Company.vue";
import Government from "@/view/Government.vue";
import Livelihood from "@/view/Livelihood.vue";
const routes = [
    {
        path: '/',
        name: '',
        component: Index
    },
    {
        path: '/about',
        name: 'about',
        component: AboutUs
    },
    {
        path: '/business',
        name: 'business',
        component: Business
    },
    {
        path: '/project',
        name: 'project',
        component: Project,
    },
    {
        path: '/create',
        name: 'create',
        component: Create,
    },
    {
        path: '/justCreate',
        name: 'justCreate',
        component: JustCreate,
    },{
        path: '/cooperate',
        name: 'cooperate',
        component: Cooperate,
    },{
        path: '/service',
        name: 'service',
        component: Service,
    },{
        path: '/company',
        name: 'company',
        component: Company,
    },{
        path: '/government',
        name: 'government',
        component: Government,
    },{
        path: '/livelihood',
        name: 'livelihood',
        component: Livelihood,
    }
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
})

export default router
